import { Injectable } from '@angular/core';
// import { StageService } from './stage.service';
import { SizeHelperService } from './size-helper.service';
import { ProductsService } from './products.service';
// import { DataForDisplayingMenuItemsService } from './data-for-displaying-menu-items.service';
// import { ConstantsService } from './constants.service';
// import { InfillsService } from './InfillsService';
import { ModelLoaderService } from './model-loader.service';

declare const THREE: any;

@Injectable()
export class SetPositionsForPostsService {
  points: any;
  dHeight: any;
  edges: any;
  widths: any;
  counts: any;
  insideCornerPost: any;
  cornerPost: any;
  intermediatePost: any;

  constructor(
    // private stage: StageService,
    private sizeHelper: SizeHelperService,
    private productSrvc: ProductsService,
    // private dataForMenu: DataForDisplayingMenuItemsService,
    // private constants: ConstantsService,
    // private infills: InfillsService,
    private modelLoaderService: ModelLoaderService
  ) { }

  setPositionsForIntermediatePosts(floor, maximumWidth, intermediatePoints, TerminationPostsPositions, intermediatePost, cornerPost) {
    intermediatePoints = [];
    this.counts = [];
    this.widths = [];

    this.edges = [];

    // for (let i = 0; i < floor.userData.points.length; i++) {

    // }

    for (let i = 0; i < floor.userData.edges.length; i++) {

      this.edges[i] = floor.userData.edges[i];
    }

    this.setPositionsForTerminationPosts(floor, TerminationPostsPositions, intermediatePost);

    for (let i = 0; i < this.edges.length; i++) {
      let A = this.edges[i === 0 ? this.edges.length - 1 : i - 1].firstPoint,
        B: any = this.edges[i].firstPoint,
        C: any = this.edges[i].secondPoint,
        D = this.edges[(i + 1) % this.edges.length].secondPoint;

      const BA = new THREE.Vector3(A.x - B.x, 0, A.y - B.y),
        BC = new THREE.Vector3(C.x - B.x, 0, C.y - B.y),
        CB = new THREE.Vector3(B.x - C.x, 0, B.y - C.y),
        CD = new THREE.Vector3(D.x - C.x, 0, D.y - C.y);

      const norm = new THREE.Vector3(0, 0, -1);
      let angle = norm.angleTo(BC);// - Math.PI / 2;
      if (norm.z * BC.x - norm.x * BC.z < 0 && norm.x * BC.x + norm.z * BC.z >= 0) {
        angle += Math.PI;
      }

      if (intermediatePost.userData.entity.mountType === 'Fascia Bracket Mount') {
        angle += Math.PI / 2;
        BC.set(BC.z, 0, -BC.x);
      }

      let leftOffset,
        rightOffset;

      const leftOffsetVector = BC.clone(),
        rightOffsetVector = CB.clone();

      if (cornerPost.userData.entity.cornerType === 'Single') {

        if (+intermediatePost.userData.entity.offset > 0) {
          if (BA.x * BC.z - BA.z * BC.x > 0) {
            leftOffsetVector.negate();
          }

          if (CB.x * CD.z - CB.z * CD.x > 0) {
            rightOffsetVector.negate();
          }
        } else {
          if (BA.x * BC.z - BA.z * BC.x < 0) {
            leftOffsetVector.negate();
          }

          if (CB.x * CD.z - CB.z * CD.x < 0) {
            rightOffsetVector.negate();
          }
        }

        leftOffset = Math.abs(this.sizeHelper.INCHToCM(2.5) + +intermediatePost.userData.entity.offset);
        rightOffset = Math.abs(this.sizeHelper.INCHToCM(2.5) + +intermediatePost.userData.entity.offset);

      } else {

        if (+intermediatePost.userData.entity.offset < 0) {
          if (BA.x * BC.z - BA.z * BC.x < 0) {
            leftOffset = 7;
          } else {
            leftOffset = 20;
          }

          if (CB.x * CD.z - CB.z * CD.x < 0) {
            rightOffset = 5;
          } else {
            rightOffset = 20;
          }
        } else {
          if (BA.x * BC.z - BA.z * BC.x < 0) {
            leftOffset = 20;
          } else {
            leftOffset = 5;
          }

          if (CB.x * CD.z - CB.z * CD.x < 0) {
            rightOffset = 20;
          } else {
            rightOffset = 5;
          }
        }
      }

      leftOffsetVector.setLength(leftOffset);
      rightOffsetVector.setLength(rightOffset);

      B = new THREE.Vector3(B.x, 0, B.y);
      C = new THREE.Vector3(C.x, 0, C.y);
      B.add(leftOffsetVector);
      C.add(rightOffsetVector);

      const X = new THREE.Vector3(this.edges[i].firstPoint.x, 0, this.edges[i].firstPoint.y);

      const length = B.distanceTo(C);

      let width, count;

      if (maximumWidth > length) {
        width = length;
        count = 0;
      } else {
        for (let j = 1; maximumWidth * (j - 1) < length; j++) {
          width = length / j;
          count = j - 1;
        }
      }
      this.widths.push(width);
      this.counts.push(count);
      // console.log(count, width);


      const points = [];
      const firstPoint = new THREE.Vector3(B.x, this.dHeight, B.z);

      const wallDirection = new THREE.Vector3(C.x - B.x, 0, C.z - B.z);

      wallDirection.normalize();
      wallDirection.multiplyScalar(width);
      const offsetVector = new THREE.Vector3(- wallDirection.z, 0, wallDirection.x);

      let offset = this.sizeHelper.INCHToCM(2.5);
      if (intermediatePost.userData.entity) {
        offset += +intermediatePost.userData.entity.offset;
      }

      if (offset < 0) {
        offset = -offset;
        offsetVector.negate();
      }

      offsetVector.setLength(offset);
      X.add(offsetVector);

      const XVector = CB.clone();
      XVector.setLength(15);
      X.add(leftOffsetVector);
      X.add(XVector);

      for (let j = 0; j < count + 2; j++) {

        const p = firstPoint.clone();
        firstPoint.add(wallDirection);

        p.add(offsetVector);
        p.rotation = angle;
        p.X = X;
        p.rotationVector = BC.clone();
        points.push(p);

      }

      if (this.edges[i].isFirstPointTerminationPost) {
        points[0].isTerminationPost = true;
      }
      if (this.edges[i].isSecondPointTerminationPost) {
        points[count + 1].isTerminationPost = true;
      }

      intermediatePoints.push(points);
    }

  }

  setPositionsForTerminationPosts(floor, TerminationPostsPositions, intermediatePost) {

    TerminationPostsPositions = [];

    for (let i = 0, j = 0; i < floor.userData.points.length; i++ , j++) {
      if (floor.userData.points[i].superstructureType) {
        //  === 'straightStair' || floor.userData.points[i].superstructureType === 'stairLandingStraight'
        //   || floor.userData.points[i].superstructureType === 'stairLandingLeft' || floor.userData.points[i].superstructureType === 'stairLandingRight'
        //   || floor.userData.points[i].superstructureType === 'stairLandingBothSides') {

        let length = Math.pow(
          (Math.pow((floor.userData.points[i].x - floor.userData.points[(i + 1) % floor.userData.points.length].x), 2) +
            Math.pow((floor.userData.points[i].y - floor.userData.points[(i + 1) % floor.userData.points.length].y), 2)
          ), 0.5
        );

        if ((floor.userData.points[i].superstructureType === 'tier2StepUp' ||
          floor.userData.points[i].superstructureType === 'tier3StepUp' ||
          floor.userData.points[i].superstructureType === 'tier2StepDown' ||
          floor.userData.points[i].superstructureType === 'tier3StepDown') && !floor.userData.points[i].parent) {
          // this.infills.addHandrailAndBaserailForTierSteps(floor, floor.userData.points[i].tier);
        }

        if (!floor.userData.points[i].length || (floor.userData.points[i].length + 10 > length)) {
          this.edges.splice(j, 1);
          j--;
          floor.userData.points[i].notCorner = true;
          floor.userData.points[(i + 1) % floor.userData.points.length].notCorner = true;

          const edge: any = {
            firstPoint: floor.userData.points[i],
            secondPoint: (i + 1) === floor.userData.points.length ? floor.userData.points[0] : floor.userData.points[i + 1]
          };

          // refactor height!!!!!!!!!
          let centerPoint: any;
          if (edge.firstPoint.distance) {
            centerPoint = new THREE.Vector3(edge.firstPoint.x, this.dHeight, edge.firstPoint.y);
            const vect = new THREE.Vector3(edge.secondPoint.x - edge.firstPoint.x, 0, edge.secondPoint.y - edge.firstPoint.y);
            vect.setLength(edge.firstPoint.distance);
            centerPoint.add(vect);
          } else {
            centerPoint = new THREE.Vector3(
              (edge.firstPoint.x + edge.secondPoint.x) / 2,
              this.dHeight,
              (edge.firstPoint.y + edge.secondPoint.y) / 2
            );
          }

          // let offset = new THREE.Vector3(
          //   this.edges[i].firstPoint.x - this.edges[i].secondPoint.x,
          //   0,
          //   this.edges[i].firstPoint.y - this.edges[i].secondPoint.y
          // );
          // offset.setLength(
          //   this.constants.inermediateStepSize.width / 2 - this.sizeHelper.INCHToCM(2.5) - +intermediatePost.userData.entity.offset
          // );
          const offset = new THREE.Vector3(edge.firstPoint.x - edge.secondPoint.x, 0, edge.firstPoint.y - edge.secondPoint.y);
          offset.setLength(length / 2 - (this.sizeHelper.INCHToCM(2.5) + +intermediatePost.userData.entity.offset));
          const normal = new THREE.Vector3(offset.z, 0, -offset.x);
          normal.setLength(this.sizeHelper.INCHToCM(2.5) + +intermediatePost.userData.entity.offset);
          const leftPoint = centerPoint.clone();
          leftPoint.add(offset);
          offset.negate();
          const rightPoint = centerPoint.clone();
          rightPoint.add(offset);

          const lPoint = leftPoint.clone();
          const rPoint = rightPoint.clone();
          lPoint.add(normal);
          rPoint.add(normal);

          rPoint.vector = normal;
          lPoint.vector = normal;

          // offset.setLength((this.sizeHelper.INCHToCM(2.5) + +intermediatePost.userData.entity.offset));
          // rPoint.add(offset);
          // offset.negate();
          // lPoint.add(offset);

          TerminationPostsPositions.push(lPoint, rPoint);
        } else {

          floor.userData.points[i].notCorner = false;
          floor.userData.points[i].isTerminationPost = true;
          floor.userData.points[(i + 1) % floor.userData.points.length].notCorner = false;
          floor.userData.points[(i + 1) % floor.userData.points.length].isTerminationPost = true;

          if (floor.userData.points[i].distance < floor.userData.points[i].length / 2 + 10) {
            floor.userData.points[i].notCorner = true;
          }

          if (length - floor.userData.points[i].distance < floor.userData.points[i].length / 2 + 10) {
            floor.userData.points[(i + 1) % floor.userData.points.length].notCorner = true;
          }

          length = floor.userData.points[i].length ? floor.userData.points[i].length : length;
          const edge: any = {
            firstPoint: floor.userData.points[i],
            secondPoint: (i + 1) === floor.userData.points.length ? floor.userData.points[0] : floor.userData.points[i + 1]
          };

          // refactor height!!!!!!!!!
          let centerPoint: any;
          if (edge.firstPoint.distance) {
            centerPoint = new THREE.Vector3(
              edge.firstPoint.x,
              this.dHeight,
              edge.firstPoint.y
            );
            const vect = new THREE.Vector3(
              edge.secondPoint.x - edge.firstPoint.x,
              0,
              edge.secondPoint.y - edge.firstPoint.y
            );
            vect.setLength(edge.firstPoint.distance);
            centerPoint.add(vect);
          } else {
            if (edge.firstPoint.superstructureType) {
              centerPoint = new THREE.Vector3(edge.firstPoint.x, this.dHeight, edge.firstPoint.y);
              const vect = new THREE.Vector3(
                edge.secondPoint.x - edge.firstPoint.x,
                0,
                edge.secondPoint.y - edge.firstPoint.y
              );
              vect.setLength(edge.firstPoint.superstructure.userData.config.distance);
              centerPoint.add(vect);
            } else {

              centerPoint = new THREE.Vector3(
                (edge.firstPoint.x + edge.secondPoint.x) / 2,
                this.dHeight,
                (edge.firstPoint.y + edge.secondPoint.y) / 2
              );
            }
          }
          // let offset = new THREE.Vector3(
          //   this.edges[i].firstPoint.x - this.edges[i].secondPoint.x,
          //   0,
          //   this.edges[i].firstPoint.y - this.edges[i].secondPoint.y
          // );
          // offset.setLength(
          //   this.constants.inermediateStepSize.width / 2 - this.sizeHelper.INCHToCM(2.5) - +intermediatePost.userData.entity.offset
          // );
          const offset = new THREE.Vector3(edge.firstPoint.x - edge.secondPoint.x, 0, edge.firstPoint.y - edge.secondPoint.y);
          offset.setLength(length / 2 - (this.sizeHelper.INCHToCM(2.5) + +intermediatePost.userData.entity.offset));
          const normal = new THREE.Vector3(offset.z, 0, -offset.x);
          normal.setLength(this.sizeHelper.INCHToCM(2.5) + +intermediatePost.userData.entity.offset);
          const leftPoint = centerPoint.clone();

          const shift = new THREE.Vector3(offset.x, offset.y, offset.z);
          shift.setLength(this.sizeHelper.INCHToCM(2.5) + +intermediatePost.userData.entity.offset);
          shift.negate();
          leftPoint.add(offset);
          offset.negate();
          const rightPoint = centerPoint.clone();
          rightPoint.add(offset);

          const lPoint = leftPoint.clone();
          const rPoint = rightPoint.clone();
          lPoint.add(normal);
          rPoint.add(normal);

          leftPoint.add(shift);
          shift.negate();
          rightPoint.add(shift);

          rPoint.vector = normal;
          lPoint.vector = normal;

          // offset.setLength((this.sizeHelper.INCHToCM(2.5) + +intermediatePost.userData.entity.offset));
          // rPoint.add(offset);
          // offset.negate();
          // lPoint.add(offset);

          TerminationPostsPositions.push(lPoint, rPoint);

          const firstEdge = {
            firstPoint: floor.userData.points[i],
            secondPoint: new THREE.Vector2(leftPoint.x, leftPoint.z),
            isFirstPointTerminationPost: false,
            isSecondPointTerminationPost: true
          },
            secondEdge = {
              firstPoint: new THREE.Vector2(rightPoint.x, rightPoint.z),
              secondPoint: (i + 1) === floor.userData.points.length ? floor.userData.points[0] : floor.userData.points[i + 1],
              isFirstPointTerminationPost: true,
              isSecondPointTerminationPost: false
            };

          // firstEdge.isSecondPointTerminationPost = true;
          // secondEdge.isFirstPointTerminationPost = true;

          this.edges.splice(j, 1, firstEdge, secondEdge);
          j++;
        }
      } else {
        // this.edges[i].firstPoint.isTerminationPost = false;
        // this.edges[i].secondPoint.isTerminationPost = false;
      }
    }

  }

  setPositionsForCornerPosts(floor, cornerPoints, rotations, insideCornerPost, cornerPost) {
    cornerPoints = [];
    rotations = [];

    this.points = floor.userData.points;

    for (let i = 0; i < this.points.length; i++) {
      const point = new THREE.Vector3(this.points[i].x, this.dHeight, this.points[i].y);

      const A = this.points[i],
        B = this.points[(i + 1) % this.points.length],
        C = this.points[i === 0 ? this.points.length - 1 : i - 1];
      const firstWallVector = new THREE.Vector3(B.x - A.x, 0, B.y - A.y);
      const secondWallVector = new THREE.Vector3(C.x - A.x, 0, C.y - A.y);

      const orient = firstWallVector.x * secondWallVector.z - firstWallVector.z * secondWallVector.x;

      const norm = new THREE.Vector3(0, 0, 1);

      if (+cornerPost.userData.entity.offset >= 0) {
        var n = cornerPost.userData.entity ?
                this.sizeHelper.INCHToCM(2.5) + +cornerPost.userData.entity.offset * Math.cos(Math.PI / 4) :
                16;

        firstWallVector.setLength(n);
        secondWallVector.setLength(n);

        if (orient >= 0) {
          var inside = false;

          var angle = firstWallVector.angleTo(norm);
          if (firstWallVector.z > 0) {
            norm.negate();
            angle = firstWallVector.angleTo(norm) + Math.PI;
          }

        } else {
          if (cornerPost.userData.entity.cornerType === 'Double') {
            n = 3.7;
          } else {
            n = 7.7;
          }

          var inside = true;

          var angle = firstWallVector.angleTo(norm) + Math.PI / 2;
          if (firstWallVector.z > 0) {
            norm.negate();
            angle = firstWallVector.angleTo(norm) + 3 * Math.PI / 2;
          }

          firstWallVector.negate();
          secondWallVector.negate();
        }

      } else {
        var n = cornerPost.userData.entity ?
                this.sizeHelper.INCHToCM(2.5) + +cornerPost.userData.entity.offset * Math.cos(Math.PI / 4) :
                16;

        if (orient >= 0) {
          var inside = false;

          var angle = firstWallVector.angleTo(norm);
          if (firstWallVector.z > 0) {
            norm.negate();
            angle = firstWallVector.angleTo(norm) + Math.PI;
          }
          console.log(angle);
        } else {
          n = insideCornerPost.userData.entity ?
                -this.sizeHelper.INCHToCM(2.5) + +insideCornerPost.userData.entity.offset * Math.cos(Math.PI / 4) :
                7;

          var inside = true;

          var angle = firstWallVector.angleTo(norm) + Math.PI / 2;
          if (firstWallVector.z > 0) {
            norm.negate();
            angle = firstWallVector.angleTo(norm) + 3 * Math.PI / 2;
          }


        }

        if (cornerPost.userData.entity.mountType === 'Fascia Bracket Mount') {
          angle -= Math.PI / 2;
        }

      }

      let non90 = false;
      firstWallVector.setLength(n);
      secondWallVector.setLength(n);
      const scalarM = firstWallVector.x * secondWallVector.x + firstWallVector.z * secondWallVector.z;
      if (scalarM < -0.05 || scalarM > 0.05) {
        non90 = true;
      }
      const rot = secondWallVector.clone();
      rot.normalize();
      const med = new THREE.Vector3(firstWallVector.x + secondWallVector.x, 0, firstWallVector.z + secondWallVector.z);
      // var norm = new THREE.Vector3(1, 0, 0);//
      // var angle = Math.acos(rot.x);//secondWallVector.angleTo(norm);// + Math.PI / 4;

      // if (firstWallVector.x * secondWallVector.z - firstWallVector.z * secondWallVector.x < 0) {//
      // && norm.x * secondWallVector.z - norm.z * secondWallVector.x > 0) {
      //   angle += Math.PI / 2;
      // }


      // is inside angle?
      // if (orient < 0) {
      // firstWallVector.negate();
      // secondWallVector.negate();
      //   var inside = true;
      //   // angle -= Math.PI / 2;
      //   n = 4;
      //   console.log('inside: ', i);
      // } else {

      // }

      // rotations.push(angle);
      // if (cornerPost.userData.entity.mountType === 'Fascia Bracket Mount') {
      //   angle -= Math.PI / 2;
      // }
      rotations.push(angle);

      firstWallVector.setLength(n);
      secondWallVector.setLength(n);

      point.inside = inside;

      point.add(firstWallVector);
      point.add(secondWallVector);
      if (non90) {
        point.non90 = true;
      }

      cornerPoints.push(point);
      if (this.points[i].notCorner) {
        cornerPoints[cornerPoints.length - 1].notCorner = true;
      }
    }
  }

  private loadInsideCornerPostModel(): Promise<any> {

    const promise = new Promise((resolve, reject) => {
      const insCornerPostEntity = this.productSrvc.getCurrentInsideCornerPost();

      this.modelLoaderService.loadModel(insCornerPostEntity).then(model => {
        this.insideCornerPost = model.clone();
        resolve();
      });
    });
    return promise;
  }

  private loadCornerPostModel(): Promise<any> {

    const promise = new Promise((resolve, reject) => {
      const cornerPostEntity = this.productSrvc.getCurrentCornerPost();

      this.modelLoaderService.loadModel(cornerPostEntity).then(model => {
        this.cornerPost = model.clone();
        resolve();
      });
    });
    return promise;
  }


  private loadIntermediatePostModel(): Promise<any> {
    const promise = new Promise((resolve, reject) => {
      const intPostEntity = this.productSrvc.getCurrentIntermidiatePost();

      this.modelLoaderService.loadModel(intPostEntity).then(model => {
        this.intermediatePost = model.clone();
        resolve();
      });
    });
    return promise;
  }


}



// WEBPACK FOOTER //
// ./src/app/services/set-positions-for-posts.service.ts